import DateAndPriceData from "./interfaces/dateAndPriceData";
import CalendarData from "./interfaces/calendarData";
import Settings from "./interfaces/settings";
import UpdatedAppointment from "./interfaces/updatedAppointment";

export interface IState {
    selectedAppointment: string,
    dateAndPriceData: DateAndPriceData,
    calendarData: CalendarData[],
    isFetching: boolean,
    settings: Settings,
    toggleState: {
        showMore: boolean,
        showMoreAppointments: boolean,
        shownItems: number
    },
    showAllAirports: boolean,
    isInCheckout: boolean,
    updatedAppointment?: UpdatedAppointment,
    loadingMode: boolean,
    scrollMonthIntoView: boolean
}

export const initialState: IState = {
    selectedAppointment: '',
    dateAndPriceData: {
        months: [
            {
                month: '',
                year: '',
                firstCheapest: true,
                appointments: [],
                minPrice: 0
            }
        ],
        airports: [],
        minPrice: 0,
        tripUid: 0,
        fares: [],
        currency: ''
    },
    calendarData: [],
    isFetching: true,
    settings: {
        trip: 0,
        organizer: '',
        commissionModel: '',
        onlyNonBinding: false,
        tripType: '',
        tripUrl: '',
        checkout: '',
        locale: ''
    },
    toggleState: {
        showMore: false,
        showMoreAppointments: false,
        shownItems: 5
    },
    showAllAirports: false,
    isInCheckout: false,
    updatedAppointment: undefined,
    loadingMode: false,
    scrollMonthIntoView: false
};
